import type { RecursiveObject } from '@chakra-ui/react';

export const fonts: RecursiveObject<string> = {
  heading: 'Brix Sans, sans-serif',
  body: 'Brix Sans, sans-serif',
};
